import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dropdown, Menu } from 'antd'
import { get } from 'lodash'
import I18n from 'I18n'

ButtonControl.propTypes = {
  constructorFunctions: PropTypes.object.isRequired,
  withinDropdown: PropTypes.bool
}

export default function ButtonControl({
  constructorFunctions,
  withinDropdown = false
}) {
  return (
    <Dropdown
      key='control'
      placement='bottomRight'
      trigger={['click']}
      overlay={
        <Menu>
          <Menu.Item key='a'>
            <Button
              className={withinDropdown ? 'btn-within-dropdown' : ''}
              type='link'
              onClick={e => {
                e.stopPropagation() // necessary to prevent the click event from bubbling up when use in a dropdown's table rown
                get(constructorFunctions, 'askCleaningPhase1Control')()
              }}
            >
              {I18n.t('pages.permits.actions.controlCleaning.phase1')}
            </Button>
          </Menu.Item>
          <Menu.Item key='b'>
            <Button
              className={withinDropdown ? 'btn-within-dropdown' : ''}
              type='link'
              onClick={e => {
                e.stopPropagation() // necessary to prevent the click event from bubbling up when use in a dropdown's table rown
                get(constructorFunctions, 'askCleaningPhase2Control')()
              }}
            >
              {I18n.t('pages.permits.actions.controlCleaning.phase2')}
            </Button>
          </Menu.Item>
        </Menu>
      }
    >
      <Button
        className={withinDropdown ? 'btn-within-dropdown' : ''}
        icon='edit'
        type={withinDropdown ? 'ghost' : ''}
        onClick={e => e.stopPropagation()}
      >
        {I18n.t('pages.permits.actions.controlCleaning.title')}
      </Button>
    </Dropdown>
  )
}
